export default __webpack_public_path__ + "static/media/daily_max_purchase.cacd0b2e.png";